// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NewRow .form-control {\r\n    width: 100% !important;\r\n}\r\n\r\n.NewRow.tr:hover {\r\n    background: none !important;\r\n}", ""]);
// Exports
module.exports = exports;
